module.exports = __webpack_public_path__ + "static/media/scrumIcon.5d4d51b7.png";